import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ArticleCard from './ArticleCard';
import ModalPage from './ModalPage';
import useDataFetch from '../hooks/useDataFetch';
import FavoriteButton from './FavoriteButton';
import axios from 'axios';

const ArticlePage = () => {
  const { articleId } = useParams();
  const navigate = useNavigate();
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await axios.get('/api/auth/me');
        setAuthUser(res.data || null);
      } catch (error) {
        setAuthUser(null);
      }
    };
    checkAuth();
  }, []);

  const fetchArticle = async () => {
    const response = await fetch(`/api/article/${articleId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch article');
    }
    return response.json();
  };

  const { data: article, loading, error } = useDataFetch(fetchArticle, [articleId]);

  const handleClose = () => {
    navigate('/');
  };

  return (
    <ModalPage
      title={article?.title || 'Article'}
      loading={loading}
      error={error}
      notFound={!loading && !error && !article}
      onClose={handleClose}
    >
      <section className="briefing-section">
        <h2 className="briefing-section-title">Article Details</h2>
        <div className="d-flex justify-content-end mb-2">
          {authUser && article?.id && (
            <FavoriteButton articleId={article.id} storyType={'day'} authUser={authUser} />
          )}
        </div>
        <div className="articles-container">
          <ArticleCard 
            article={article} 
            showFullText={true}
            alwaysExpanded={true}
          />
        </div>
      </section>
    </ModalPage>
  );
};

export default ArticlePage;